import { onMounted, onBeforeUnmount, ref, Ref } from 'vue'

type Callback = () => void
export function useInterval(callback: Callback, delay: number) {
    if (typeof delay !== 'number' || delay <= 0) {
        throw new Error('The "delay" parameter must be a positive number.')
    }

    const isRunning: Ref<boolean> = ref(false) 
    let intervalId: number | undefined

    const start = () => {
        if (!isRunning.value) {
            intervalId = window.setInterval(callback, delay) 
            isRunning.value = true
        }
    }

    const stop = () => {
        if (isRunning.value) {
            if (intervalId !== undefined) {
                clearInterval(intervalId) 
                intervalId = undefined
            }
            isRunning.value = false
        }
    }

    onMounted(() => {
        start()
    })

    onBeforeUnmount(() => {
        stop()
    })

    return {
        start,
        stop,
        isRunning,
    }
}
